import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";
import axios from "axios";

export const AdminTask = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("All");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getData = async () => {
    try {
      setLoader(true);
      const response = await api.getTasks();
      if (response?.success) {
        setData(response?.tasks || []);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Apply filter whenever data or filter changes
  useEffect(() => {
    if (statusFilter === "All") {
      setFilteredData(data);
    } else {
      setFilteredData(data.filter((task) => task?.status === statusFilter));
    }
  }, [data, statusFilter]);

  const deleteEmployee = async (id) => {
    try {
      const response = await api.deleteTask(id);
      if (response?.success) {
        notify.success("Task deleted successfully!");
        getData();
      }
    } catch (error) {
      notify.error("Something went wrong!");
    }
  };

  const handleFilterChange = (value) => {
    setStatusFilter(value);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row mb-3">
          <div className="col d-flex justify-content-between align-items-center">
            <h3>Tasks</h3>

            {/* 🔽 Filter Dropdown */}
            <select
              className="form-select w-auto"
              value={statusFilter}
              onChange={(e) => handleFilterChange(e.target.value)}
            >
              <option value="All">All</option>
              <option value="To Do">To Do</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <Table data={filteredData} deleteEmployee={deleteEmployee} />
          </div>
        </div>

        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>

      <CreateTaskModal
        show={show}
        handleClose={handleClose}
        getTask={getData}
      />
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data, deleteEmployee }) => {
  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Assigned To</th>
                <th scope="col">Priority</th>
                <th scope="col">Assign At</th>
                <th scope="col">Deadline</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No tasks available
                  </td>
                </tr>
              ) : (
                data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.title}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark">{item?.description}</div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.assignedTo?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.priority}
                      </span>
                    </td>
                    <td>
                      {item?.createdAt ? formatDate(item?.createdAt) : "-"}
                    </td>
                    <td>
                      {Array.isArray(item?.deadline)
                        ? item?.deadline.join(", ")
                        : item?.deadline
                          ? formatDate(item?.deadline)
                          : "-"}
                    </td>
                    <td>{item?.status}</td>
                    <td>
                      <div
                        className="delete p-2 ms-1 cursor-pointer"
                        onClick={() => deleteEmployee(item?._id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const CreateTaskModal = ({ show, handleClose, getTask }) => {
  const [employees, setEmployees] = useState([]);
  const [data, setData] = useState({});
  const [useDueDate, setUseDueDate] = useState(false);
  const [useDaysOfWeek, setUseDaysOfWeek] = useState(false);

  const getData = async () => {
    try {
      let token = localStorage.getItem("admintoken");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.getEmployees();
      if (response?.success) {
        setEmployees(response?.employees || []);
      }
    } catch (error) {
      notify.error("Something went wrong!");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSubmit = async () => {
    try {
      let payload = {
        title: data?.title,
        description: data?.description,
        assignedTo: data?.assignedTo,
        deadline: useDueDate ? data?.deadline : data?.daysOfWeek,
        priority: data?.priority,
      };

      const response = await api.addTask(payload);
      if (response?.success) {
        getTask();
        notify.success("Task successfully added!");
        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Create Task</div>
        <div className="row">
          {/* Title */}
          <div className="col-12">
            <div className="form-group">
              <label>Task Title</label>
              <input
                type="text"
                name="title"
                className="form-control"
                onChange={onTextChange}
              />
            </div>
          </div>

          {/* Description */}
          <div className="col-12">
            <div className="form-group">
              <label>Task Description</label>
              <textarea
                rows={3}
                name="description"
                className="form-control"
                onChange={onTextChange}
              ></textarea>
            </div>
          </div>

          {/* Assignee */}
          <div className="col-12">
            <div className="form-group">
              <label>Assignee</label>
              <select
                name="assignedTo"
                className="form-control"
                onChange={onTextChange}
              >
                <option value="">Select</option>
                {employees.map((item, key) => (
                  <option value={item?._id} key={key}>
                    {item?.fullName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Due Date */}
          <div className="col-lg-6">
            <div className="form-group">
              <label>Due Date</label>
              <input
                type="date"
                name="deadline"
                className="form-control"
                disabled={useDaysOfWeek}
                onChange={(e) => {
                  if (!e.target.value) {
                    setUseDueDate(false);
                  } else {
                    setUseDueDate(true);
                    setUseDaysOfWeek(false);
                  }
                  onTextChange(e);
                }}
              />
            </div>
          </div>

          {/* Days of Week */}
          <div className="col-lg-6">
            <div className="form-group">
              <label>Days of Week</label>
              <div className="d-flex flex-wrap">
                {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                  (day) => (
                    <label key={day} className="me-2">
                      <input
                        type="checkbox"
                        value={day}
                        disabled={useDueDate}
                        checked={data?.daysOfWeek?.includes(day) || false}
                        onChange={(e) => {
                          let selectedDays = data?.daysOfWeek || [];
                          if (selectedDays.includes(day)) {
                            selectedDays = selectedDays.filter(
                              (d) => d !== day,
                            );
                          } else {
                            selectedDays.push(day);
                          }
                          setData({ ...data, daysOfWeek: selectedDays });
                          if (selectedDays.length === 0) {
                            setUseDaysOfWeek(false);
                          } else {
                            setUseDaysOfWeek(true);
                            setUseDueDate(false);
                          }
                        }}
                      />{" "}
                      {day}
                    </label>
                  ),
                )}
              </div>
            </div>
          </div>

          {/* Priority */}
          <div className="col-12">
            <div className="form-group">
              <label>Priority</label>
              <select
                name="priority"
                className="form-control"
                onChange={onTextChange}
              >
                <option value="">Select</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};
